import ReviewSummaryReportProvider from './Containers/ReviewSummaryReportProvider';
import ReviewSummaryReportSections from './ReviewSummaryReportSections';

const ReviewSummaryReport = () => {
  return (
    <ReviewSummaryReportProvider>
      <ReviewSummaryReportSections />
    </ReviewSummaryReportProvider>
  );
};

export default ReviewSummaryReport;
